// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/NewsArticle/article.sass
// module id = 546
// module chunks = 0